import React, { useState } from 'react';
import { Tooltip } from '@mui/material';
import { calculateInsights } from '../../utils/insightsHelper';
import TriggersModal from './TriggersModal';
import './styles.css';

const DataHighlights = ({ objectType, data }) => {
  const [triggersModalOpen, setTriggersModalOpen] = useState(false);
  const insights = calculateInsights(objectType, data);

  const getIconComponent = (iconName) => {
    const icons = {
      calendar: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M5 1V3M11 1V3M2 6H14M3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      dollar: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 1V15M11 3H6.5C5.67157 3 5 3.67157 5 4.5C5 5.32843 5.67157 6 6.5 6H9.5C10.3284 6 11 6.67157 11 7.5C11 8.32843 10.3284 9 9.5 9H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      progress: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 2V8L11 11M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      target: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="8" cy="8" r="1" fill="currentColor"/>
        </svg>
      ),
      clock: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 4V8L10.5 10.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      trending: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 12L5.5 8.5L8.5 11.5L14 6M14 6H10M14 6V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      activity: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 8H5L7 2L9 14L11 8H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      'user-check': (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M10.5 7C10.5 8.933 9.433 10.5 8 10.5C6.567 10.5 5.5 8.933 5.5 7C5.5 5.067 6.567 3.5 8 3.5C9.433 3.5 10.5 5.067 10.5 7Z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M2 14C2 12.067 4.686 10.5 8 10.5C8.704 10.5 9.374 10.587 10 10.745M11 14L12 15L14 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      briefcase: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M5 4V3C5 2.44772 5.44772 2 6 2H10C10.5523 2 11 2.44772 11 3V4M2 6V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V6M2 6C2 5.44772 2.44772 5 3 5H13C13.5523 5 14 5.44772 14 6M8 8V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      'message-circle': (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M14 7.5C14 10.5376 11.3137 13 8 13L3 15L4 11C2.21903 9.99426 1 8.37291 1 6.5C1 3.46243 3.68629 1 7 1C10.3137 1 13 3.46243 13 6.5C13 6.83511 12.9698 7.16299 12.9119 7.48139" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      users: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M12 14C12 12.067 10.314 10.5 8 10.5C5.686 10.5 4 12.067 4 14M12 10.5C12 10.5 14 10.5 14 8.5C14 6.567 12.657 5 11 5M8 7C6.343 7 5 5.657 5 4C5 2.343 6.343 1 8 1C9.657 1 11 2.343 11 4C11 5.657 9.657 7 8 7Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      'trending-up': (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 12L5.5 8.5L8.5 11.5L14 6M14 6H10M14 6V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      'dollar-sign': (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 5V11M10 6H6.5C6.22386 6 6 6.22386 6 6.5C6 6.77614 6.22386 7 6.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      building: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 14H14M3 14V3C3 2.44772 3.44772 2 4 2H9C9.55228 2 10 2.44772 10 3V14M10 6H12C12.5523 6 13 6.44772 13 7V14M5 5H6M5 8H6M5 11H6M8 5H8.01M8 8H8.01M8 11H8.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      source: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 2L8 8M8 8L5 5M8 8L11 5M3 10H13M3 13H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      user: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 7C9.657 7 11 5.657 11 4C11 2.343 9.657 1 8 1C6.343 1 5 2.343 5 4C5 5.657 6.343 7 8 7ZM4 14C4 12.067 5.686 10.5 8 10.5C10.314 10.5 12 12.067 12 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      mail: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 4C2 3.44772 2.44772 3 3 3H13C13.5523 3 14 3.44772 14 4V12C14 12.5523 13.5523 13 13 13H3C2.44772 13 2 12.5523 2 12V4Z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M2 4L8 8L14 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      phone: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M3.5 1H6.5L8 5L6.5 6C6.5 6 7 8 8 9C9 10 11 10.5 11 10.5L12 9L15 10.5V13.5C15 14.3284 14.3284 15 13.5 15C7.14873 15 2 9.85127 2 3.5C2 2.67157 2.67157 2 3.5 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      alert: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 6V9M8 11H8.01M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      'arrow-right': (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    };

    return icons[iconName] || icons.activity;
  };

  const getStatusClass = (status) => {
    return `highlight-status-${status || 'default'}`;
  };

  const handleInsightClick = (insight) => {
    if (insight.label?.includes('Triggers')) {
      setTriggersModalOpen(true);
    }
  };

  return (
    <div className="data-highlights-container">
      <h4>Data highlights</h4>
      <div className="highlights-grid">
        {insights.map((insight, index) => (
          <Tooltip
            key={index}
            title={insight.tooltip || ''}
            placement="top"
            disableHoverListener={!insight.tooltip}
          >
            <div 
              className={`highlight-box ${getStatusClass(insight.status)} ${insight.label?.includes('AI') && !insight.label?.includes('Next Best') && !insight.label?.includes('Triggers') && !insight.label?.includes('Automation') ? 'ai-insight' : ''} ${insight.label?.includes('Next Best') ? 'next-action' : ''} ${insight.label?.includes('Triggers') ? 'trigger-alert' : ''} ${insight.label?.includes('Automation') ? 'automation-tip' : ''}`}
              onClick={() => handleInsightClick(insight)}
              style={{ cursor: insight.label?.includes('Triggers') ? 'pointer' : 'default' }}
            >
              <div className="highlight-icon">
                {getIconComponent(insight.icon)}
              </div>
              <div className="highlight-content">
                <h5>{insight.label}</h5>
                <p className="highlight-value">{insight.value}</p>
                {insight.subValue && (
                  <span className="highlight-subvalue">{insight.subValue}</span>
                )}
                {insight.progress !== undefined && (
                  <div className="highlight-progress">
                    <div 
                      className="highlight-progress-bar" 
                      style={{ width: `${insight.progress}%` }}
                    />
                  </div>
                )}
              </div>
            </div>
          </Tooltip>
        ))}
      </div>
      <TriggersModal 
        open={triggersModalOpen}
        onClose={() => setTriggersModalOpen(false)}
        objectType={objectType}
        data={data}
      />
    </div>
  );
};

export default DataHighlights;